import React from 'react';
import Icon from '../../../components/AppIcon';
import { StudentGradeRow } from '../types';

interface GradebookStatsProps {
  studentRows: StudentGradeRow[];
}

const GradebookStats = ({ studentRows }: GradebookStatsProps) => {
  const calculateStats = () => {
    const totalStudents = studentRows.length;
    const gradedStudents = studentRows.filter(
      (row) => row.average !== undefined || row.overallQualification
    ).length;

    const averages = studentRows
      .map((row) => row.average)
      .filter((avg): avg is number => avg !== undefined);

    const classAverage =
      averages.length > 0
        ? averages.reduce((sum, avg) => sum + avg, 0) / averages.length
        : 0;

    const highestAverage = averages.length > 0 ? Math.max(...averages) : 0;
    const lowestAverage = averages.length > 0 ? Math.min(...averages) : 0;

    return {
      totalStudents,
      gradedStudents,
      classAverage,
      highestAverage,
      lowestAverage,
      completionRate: totalStudents > 0 ? (gradedStudents / totalStudents) * 100 : 0,
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      label: 'Total elevi',
      value: stats.totalStudents,
      icon: 'Users',
      color: 'text-primary',
    },
    {
      label: 'Elevi notați',
      value: stats.gradedStudents,
      icon: 'CheckCircle',
      color: 'text-success',
    },
    {
      label: 'Media clasei',
      value: stats.classAverage.toFixed(2),
      icon: 'TrendingUp',
      color: 'text-primary',
    },
    {
      label: 'Rată completare',
      value: `${stats.completionRate.toFixed(1)}%`,
      icon: 'Target',
      color: 'text-accent',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((stat) => (
        <div
          key={stat.label}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow duration-150"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`p-2 rounded-md bg-muted ${stat.color}`}>
              <Icon name={stat.icon} size={20} />
            </div>
          </div>
          <p className="text-2xl font-semibold text-foreground mb-1">{stat.value}</p>
          <p className="text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default GradebookStats;
